import React from 'react'
const Home = React.lazy(() => import('../pages/Home'))
const Portfolio = React.lazy(() => import('../pages/Portfolio'))
const About = React.lazy(() => import('../pages/About'))
const School = React.lazy(() => import('../pages/School'))
const Connection = React.lazy(() => import('../pages/Contact'))
const Proekt=React.lazy(()=>import("../pages/Proekt"))
export const routers=[
 {
     path:"/",
     Component:Home
 },
 {
     path:"/portfolio",
     Component:Portfolio
 },
 {
     path:"/portfolio/:id",
     Component:Proekt
 },
 {
     path:"/about",
     Component:About
 },
 {
     path:"/school",
     Component:School
 },
 {
     path:"/connection",
     Component:Connection
 }
]